import { Injectable } from "@angular/core";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { TaskCreateDialogComponent } from "../../components/task-create-dialog/task-create-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class TaskCreateCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(TaskCreateDialogComponent, {
        header: commandTemplate?.settings?.label,
        width: '760px'
      });
      this.dialogRef.onClose.subscribe((result) => {
        // result is true or false, indiciating if it should refetch
        if(result){
          let parameterObject = {
            taskInput: result
          }
          commandInput.parameters = parameterObject;
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });
  }
  
}